import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import { Link } from '~/components/Link'
import ROUTES from '~/shared/constants/routes.const'
import { GET_STARTED_ENTRY_URL } from '~/get-started/entryRoute.const'
import loginAnalytics from '~/analytics/login/loginAnalytics'

import { getRouterQueryFrom } from '../utils/auth.utils'

interface QUERY_REUTRN_TYPE {
  [key: string]: string
}

export function LoginExistingAccount(): React.ReactElement {
  const router = useRouter()
  const { t } = useTranslation('logIn')

  const redirectFrom = (router.query.from || router.query.state) as string | undefined
  const hasRedirectFrom = redirectFrom && redirectFrom !== 'undefined'
  const isRedirectingToTOD =
    hasRedirectFrom && (redirectFrom.startsWith('booking') || redirectFrom.startsWith('/no/campaigns/dnb'))
  const isFamilyInvite = router.pathname === ROUTES.FAMILY_ACCEPT_INVITE
  const isRegisterTarget = Boolean(isRedirectingToTOD || isFamilyInvite)
  const entryQuery = isRegisterTarget ? {} : GET_STARTED_ENTRY_URL.query

  const href = {
    pathname: isRegisterTarget ? ROUTES.REGISTER : GET_STARTED_ENTRY_URL.pathname,
    query: { ...entryQuery, ...router.query },
  }

  const getQuery = (): QUERY_REUTRN_TYPE => {
    const GAME_PATH = getRouterQueryFrom(router)
    return (GAME_PATH ? { ...router.query, from: GAME_PATH } : router.query) as QUERY_REUTRN_TYPE
  }

  const handleOnClickSignupBtn =
    (to: string) =>
    (e: Event): void => {
      e.preventDefault()
      loginAnalytics.logButtonClick('signup_button')
      router.push({
        pathname: to,
        query: { ...entryQuery, ...getQuery() },
      })
    }
  return (
    <div className="text-center">
      <span>{t('noUser')}</span>
      <span>&nbsp;</span>
      <Link
        className="font-medium text-purple-electric hover:underline"
        onClick={handleOnClickSignupBtn(href.pathname)}
        to={href}
      >
        {t('signUp')}
      </Link>
    </div>
  )
}
